export default __webpack_public_path__ + "static/media/img_selected-industry-events.5d7753f0.svg";